import Icon from '@minecraft.icon';
import styled from 'styled-components';
import { AdvancedVideo } from '@cloudinary/react';
import { Video } from 'cloudinary-react';

export const StyledCloudinaryVideo = styled(Video)<{
  $isVideo?: boolean;
  $wrapperHeight: number | string;
  $wrapperWidth: number | string;
  $responsiveWidth?: boolean;
}>`
  height: ${(props): string => `${props.$wrapperHeight}px`};
  width: ${(props): string => (props.$responsiveWidth ? '100%' : `${props.$wrapperWidth}px`)};
  outline: 0;
  background-color: ${(props): string => (props.$isVideo ? 'black' : 'transparent')};
`;

export const StyledCloudinaryVideoPlayer = styled(AdvancedVideo)<{
  $isThumbnail?: boolean;
  $wrapperHeight: number | string;
  $wrapperWidth: number | string;
  $responsiveWidth?: boolean;
}>`
  height: ${(props): string => `${props.$wrapperHeight}px`};
  width: ${(props): string => (props.$responsiveWidth ? '100%' : `${props.$wrapperWidth}px`)};
  outline: 0;
  background-color: black;
`;

export const StyledVideoThumbnailContainer = styled.div<{ height: number | string; width: number | string }>`
  height: ${(props): string => `${props.height}px`};
  width: ${(props): string => `${props.width}px`};
  position: relative;
`;

export const StyledPlayVideoIcon = styled(Icon)`
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  height: 1.5rem;
  max-height: 50%;
  width: 1.5rem;
`;

export const StyledLinkWrapper = styled.div`
  line-height: 1.5;
`;
